var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeafA(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95.766,
    height: 95.762,
    viewBox: "0 0 95.766 95.762",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(-0.08 -0.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Copy",
    transform: "translate(-895 -279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto---A",
    transform: "translate(895.08 279.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-Copy-11",
    d: "M92.607.009a3.015,3.015,0,0,1,3.15,3.15C95.546,5.6,92.514,60.954,74.8,78.671c-16.978,16.978-36.986,12.995-50.051,3.6-.158-.114-.335-.25-.53-.406L12.439,93.629a7.286,7.286,0,0,1-10.3-10.3L13.9,71.549q-.237-.3-.408-.532C4.1,57.954.114,37.947,17.093,20.966,34.81,3.249,90.168.215,92.607.009Z",
    fill: "#1e8f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M62.17,67.812a4.1,4.1,0,0,0,4.38-4.119A7.73,7.73,0,0,0,66,60.909L54.513,29.759c-1.247-3.422-3.277-4.931-6.7-4.931-3.306,0-5.366,1.566-6.584,4.96L29.8,60.909a8.992,8.992,0,0,0-.58,2.784c0,2.523,1.711,4.119,4.438,4.119,2.32,0,3.625-1.16,4.438-3.945l2.2-6.526H55.412l2.2,6.613C58.4,66.681,59.7,67.812,62.17,67.812ZM53.382,50.555H42.216l5.424-17.141h.2Z",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafA);
export default __webpack_public_path__ + "static/media/LeafA.71d03b8f59a748c9a66bb8318318110f.svg";
export { ForwardRef as ReactComponent };